<div class="modal-content">
  <div class="col-12">
    <form class="box-form p-5" [formGroup]="formPasswordToken">
      <h3 class="form-title text-center">Nova Senha</h3>
      <hr>
      <div class="form-row mt-5 ">
        <h4 class="subtitle-form text-center col-12">Um código (número de 6 dígitos) foi enviado para o E-mail informado no cadastro.</h4>
      </div>
      <div class="form-row mt-4">
        <div class="col-md">
          <h3 class="title-email">
            Digite abaixo o código recebido por E-mail:
          </h3>
       </div>
      </div>

       <div class="form-row mt-5 d-flex justify-content-center">
         <div class="col-md-7">
           <div class="form-outline">
             <input data-testid="token-nova-senha" type="text" [dropSpecialCharacters]="true" formControlName="token" placeholder="Digite o código recebido por E-mail" mask=" 0   0   0   0   0   0 " class="form-control text-center">
               <span class="error-form ml-2" *ngIf="token.invalid && (token.dirty || token.touched)">Campo obrigatório.</span>
            </div>
         </div>
      </div>

      <div class="form-row mt-3 d-flex justify-content-center">
        <div class="col-md text-center">
          <span data-testid="botao-reenviar-token-senha" class="reenviar-codigo" (click)="resendEmailCode()">Reenviar código por email</span>
        </div>
      </div>

      <div class="form-row mt-5">
        <div class="form-group col-md-6">
          <label class="form-label">Digite a nova senha <b class="text-danger">*</b></label>
          <input data-testid="nova-senha" type="password" class="form-control" formControlName="newPassword">
        </div>

        <div class="form-group col-md-6">
          <label class="form-label">Confirme a nova senha <b class="text-danger">*</b></label>
          <input data-testid="confirma-nova-senha" type="password" class="form-control" formControlName="confirmNewPassword">
        </div>
      </div>

      <div class="form-row mt-5 d-flex justify-content-center">
        <div class="col-md text-center">
          <button data-testid="botao-valida-token" class="btn" (click)="validatePassword()">Validar Token</button>
        </div>
      </div>
    </form>
  </div>
</div>
